import { sportableColors } from '../../../utils/colors'
import { pitchSetupTypes } from '../../pitches/data_types'
import { defaultDoublePitch, defaultSinglePitch } from './pitch'

export const soccerProps = {
  reportMetricConfig: {
    playerPerformanceTable: {
      all: {
        metrics: {
          keys: ['involvements', 'involvementsPerMinute']
        },
        eventMetricGroup: {
          eventTypes: [
            'soccerPass',
            'soccerDribble',
            'soccerCross',
            'soccerClearance',
            'soccerPenalty',
            'soccerCorner',
            'soccerShotAtGoal'
          ],
          groupName: {
            en: 'Success %',
            fr: 'Succès %'
          }
        }
      }
    },
    playerComparisonTable: {
      pass: {
        metrics: [
          ['totalForwardPasses', 'forwardPassesCompletionRate'],
          ['totalBackwardPasses', 'backwardPassesCompletionRate'],
          ['totalSidewaysPasses', 'sidewaysPassesCompletionRate']
        ]
      }
    },
    monitoringCards: {
      technicalMetrics: [
        'involvements',
        'involvementsPerMinute',
        'totalForwardPasses',
        'forwardPassesComplete',
        'shots',
        'shotsConversion',
        'duelsWon'
      ],
      physicalMetrics: [
        'distance',
        'distancePerMin',
        'highSpeedRunningDistance',
        'highSpeedRunningDistancePerMin',
        'accelCount',
        'decelCount',
        'totalWork'
      ]
    },
    dashboardMetrics: {
      performanceAgainstAverage: [
        'totalRuns',
        'totalRunDistance',
        'runIntensity',
        'totalPasses',
        'totalForwardPasses',
        'totalBackwardPasses',
        'totalSidewaysPasses',
        'averageTimeOnBall',
        'totalShots',
        'shotConversion',
        'shotsOnTargetRatio',
        'totalShotsAtGoal',
        'averageRecycleTime',
        'totalGoalsScored',
        'totalPassCompletion'
      ],
      cardGrid: [
        ['totalDistance', 'averageMaxSpeed', 'xGImpacts'],
        ['avgInvolvements', 'totalCarries', 'completedPasses', 'totalShots']
      ]
    }
  },
  pitch: {
    default: defaultSinglePitch,
    defaultDoublePitch: defaultDoublePitch,
    pitchPointCount: 34,
    minPadding2D: 70,
    minPadding3D: 50,
    cameraYScale: 0.5,
    textureCanvasScale: 11,
    setupTypes: pitchSetupTypes,
    enableRotate: true,
    enableBench: true,
    defaultDrillRegion: {
      P1: 'P10',
      P2: 'P8',
      P3: 'P3',
      P4: 'P1',
      P5: 'P16',
      P6: 'P33',
      P7: 'P15',
      P8: 'P34'
    } as const,
    drillsGoalsOrPosts: {
      enabled: true,
      dimensions: {
        large: {
          width: 7.32,
          height: 2.44,
          depth: 2.44
        },
        small: {
          width: 1.914,
          height: 1.914,
          depth: 1.61
        }
      }
    },
    drillSnapLines: ['P1', 'P2', 'P3'],
    autosetupTagPositions: ['P2', 'P3', 'P8'],
    pitchCornerKeys: {
      topLeft: 'P10',
      topRight: 'P8',
      bottomRight: 'P3',
      bottomLeft: 'P1'
    },
    leftAutosetupRegion: {
      topLeft: 'P10',
      topRight: 'P9',
      bottomRight: 'P2',
      bottomLeft: 'P1'
    },
    rightAutosetupRegion: {
      topLeft: 'P9',
      topRight: 'P8',
      bottomRight: 'P3',
      bottomLeft: 'P2'
    },
    leftTeamRegion: {
      topLeft: 'P10',
      topRight: 'P10',
      bottomRight: 'P1',
      bottomLeft: 'P1'
    },
    rightTeamRegion: {
      topLeft: 'P8',
      topRight: 'P8',
      bottomRight: 'P3',
      bottomLeft: 'P3'
    }
  },
  features: {
    drillsEnabled: true,
    enablePromoteAllDevicesOnPitch: true,
    targetEvents: ['pass'],
    positionNumbers: false,
    maxPlayers: 18,
    defaultUnitSystem: 'Metric',
    recentEventTableMetrics: ['dist', 'hangTime', 'speed'],
    geniusAvailable: false,
    noOfPlayersInStartingLineUp: null,
    scoreboard: false,
    homeSideCheck: false,
    bibs: {
      '1': {
        name: 'No Bib',
        colour: null
      },
      '2': {
        name: 'Red',
        colour: sportableColors.colors.sportableRed
      },
      '3': {
        name: 'Blue',
        colour: sportableColors.colors.sportableBlue
      },
      '4': {
        name: 'Green',
        colour: sportableColors.colors.sportableGreen
      },
      '5': {
        name: 'Orange',
        colour: sportableColors.colors.sportableOrange
      }
    },
    defaultBibTeamDirection: [2, 3] as number[],
    targetMetrics: ['dist', 'hangTime']
  } as const,
  supportsTrackingDownload: true
}

export const soccerConfig = {
  key: 'soccer' as const,
  value: 'Soccer' as const,
  name: 'Football',
  props: soccerProps
}
